import React from 'react';
import { Chip } from '@mui/material';

type StatusKey = 'requested' | 'confirmed' | 'checked_in' | 'completed' | 'no_show' | 'cancelled';

const STATUS_MAP: Record<StatusKey, { label: string; color: 'default' | 'primary' | 'success' | 'warning' | 'error' | 'info' }> = {
  requested: { label: 'Solicitat', color: 'warning' },
  confirmed: { label: 'Confirmat', color: 'success' },
  checked_in: { label: 'Prezent', color: 'info' },
  completed: { label: 'Finalizat', color: 'primary' },
  no_show: { label: 'No-show', color: 'error' },
  cancelled: { label: 'Anulat', color: 'default' },
};

interface StatusChipProps {
  status: StatusKey;
  size?: 'small' | 'medium';
  variant?: 'filled' | 'outlined';
}

export function StatusChip({ status, size = 'small', variant = 'filled' }: StatusChipProps) {
  const s = STATUS_MAP[status];
  return <Chip size={size} label={s.label} color={s.color} variant={variant} />;
}

export default StatusChip;
